// Détecte le provider d'un lien externe et génère l'URL d'embed
// Providers supportés : YouTube, Vimeo, TikTok, SoundCloud, Instagram, Facebook, Dailymotion

const MATCHERS = [
  {
    provider: "youtube",
    label: "YouTube",
    regex: /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/,
    embed: (id) => `https://www.youtube.com/embed/${id}`,
    thumb: (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
    kind: "video",
  },
  {
    provider: "vimeo",
    label: "Vimeo",
    regex: /vimeo\.com\/(?:video\/)?(\d+)/,
    embed: (id) => `https://player.vimeo.com/video/${id}`,
    thumb: () => null,
    kind: "video",
  },
  {
    provider: "tiktok",
    label: "TikTok",
    regex: /tiktok\.com\/(?:@[^/]+\/video|v|embed)\/(\d+)/,
    embed: (id) => `https://www.tiktok.com/embed/v2/${id}`,
    thumb: () => null,
    kind: "video",
  },
  {
    provider: "dailymotion",
    label: "Dailymotion",
    regex: /dailymotion\.com\/(?:video\/|embed\/video\/)([a-z0-9]+)/i,
    embed: (id) => `https://www.dailymotion.com/embed/video/${id}`,
    thumb: () => null,
    kind: "video",
  },
  {
    provider: "soundcloud",
    label: "SoundCloud",
    regex: /soundcloud\.com\/([^\s?]+)/,
    embed: (_id, raw) => `https://w.soundcloud.com/player/?url=${encodeURIComponent(raw)}&auto_play=false&show_artwork=true&visual=true`,
    thumb: () => null,
    kind: "audio",
  },
  {
    provider: "instagram",
    label: "Instagram",
    regex: /instagram\.com\/(?:reel|p|tv)\/([A-Za-z0-9_-]+)/,
    embed: (id) => `https://www.instagram.com/p/${id}/embed`,
    thumb: () => null,
    kind: "video",
  },
  {
    provider: "facebook",
    label: "Facebook",
    regex: /facebook\.com\/(?:watch\/?\?v=|[^/]+\/videos\/)(\d+)/,
    embed: (_id, raw) => `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(raw)}&show_text=0`,
    thumb: () => null,
    kind: "video",
  },
];

export function detectExternalLink(url) {
  if (!url || typeof url !== "string") return null;
  const raw = url.trim();
  for (const m of MATCHERS) {
    const match = raw.match(m.regex);
    if (match) {
      const id = match[1];
      return {
        provider: m.provider,
        label: m.label,
        id,
        url: raw,
        embedUrl: m.embed(id, raw),
        thumbnail: m.thumb(id),
        kind: m.kind,
      };
    }
  }
  return null;
}

export function isExternalTrack(track) {
  return !!track?.external_url;
}
